<div class="page">
  <div class="page-head">
    <div class="head-left">
      <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" severity="secondary"
        pTooltip="Back" (onClick)="back()" />
      <div>
        <h2>{{ pageTitle() || 'Payment Details' }}</h2>
        <p>Full detail for a single payment — any status.</p>
      </div>
    </div>
  </div>

  @if (loading()) {
    <div class="card pad"><div class="state"><i class="pi pi-spin pi-spinner"></i><p>Loading payment…</p></div></div>
  } @else if (notFound()) {
    <div class="card pad">
      <div class="state">
        <i class="pi pi-exclamation-triangle"></i>
        <p>Payment not found, or you don't have access to it.</p>
        <p-button label="Back" icon="pi pi-arrow-left" [outlined]="true" (onClick)="back()" />
      </div>
    </div>
  } @else if (payment(); as p) {
    <!-- ===================== Summary ===================== -->
    <div class="card">
      <div class="pd-top">
        <div class="pd-title">
          <span class="pd-uid mono">{{ p.paymentUniqueId }}</span>
          <p-tag [value]="p.paymentStatus || '—'" [severity]="statusSeverity(p.paymentStatus)" />
        </div>
        <div class="pd-amount">{{ p.amount | number: '1.0-0' }} <span class="cur">{{ p.currency || 'INR' }}</span></div>
      </div>

      @if (isOpen(p)) {
        <!-- A still-open payment may already be captured at the gateway; this asks and confirms it. -->
        <div class="pd-recheck">
          <p-button
            label="Re-check with gateway"
            icon="pi pi-sync"
            severity="secondary"
            size="small"
            [loading]="rechecking()"
            (onClick)="recheck()" />
          <span class="pd-recheck-hint">
            If the customer was charged but this still says pending, re-check to confirm it.
          </span>
        </div>
      }

      @if (isPaid(p)) {
        <div class="pd-actions">
          <p-button label="View receipt" icon="pi pi-receipt" (onClick)="viewReceipt()" />
          <p-button label="Download PDF" icon="pi pi-download" [outlined]="true" (onClick)="downloadReceipt(p)" />
          <p-button label="Print" icon="pi pi-print" [outlined]="true" (onClick)="printReceipt(p)" />
        </div>
      }
    </div>

    <!-- ===================== Details ===================== -->
    <div class="card">
      <h3 class="block-title"><i class="pi pi-user"></i> Member</h3>
      <div class="kv-grid">
        <div>
          <span>Member</span>
          <strong>
            <a class="link" (click)="openMember(p)">{{ p.memberName || ('Member #' + p.memberId) }}</a>
          </strong>
        </div>
        <div><span>Member Uid</span><strong class="mono">{{ p.memberUniqueId || '—' }}</strong></div>
        <div><span>Payer</span><strong class="mono">{{ payerLabel(p) }}</strong></div>
      </div>

      <h3 class="block-title"><i class="pi pi-indian-rupee"></i> Payment</h3>
      <div class="kv-grid">
        <div><span>Payment Uid</span><strong class="mono">{{ p.paymentUniqueId }}</strong></div>
        <div><span>Amount</span><strong>{{ p.amount | number: '1.0-0' }} {{ p.currency || 'INR' }}</strong></div>
        <div><span>Status</span><strong><p-tag [value]="p.paymentStatus || '—'" [severity]="statusSeverity(p.paymentStatus)" /></strong></div>
        <div><span>Mode</span><strong>{{ p.paymentMode || '—' }}</strong></div>
        <div><span>Created</span><strong>{{ p.createdDate ? (p.createdDate | indDate) : '—' }}</strong></div>
        <div><span>Paid At</span><strong>{{ p.paidAt ? (p.paidAt | indDate) : '—' }}</strong></div>
        @if (p.failureReason) {
          <div class="span-all"><span>Failure Reason</span><strong class="danger">{{ p.failureReason }}</strong></div>
        }
      </div>

      <h3 class="block-title"><i class="pi pi-credit-card"></i> Gateway</h3>
      <div class="kv-grid">
        <div><span>Gateway</span><strong>{{ p.gatewayName || '—' }}</strong></div>
        <div><span>Gateway Order Id</span><strong class="mono">{{ p.gatewayOrderId || '—' }}</strong></div>
        <div><span>Gateway Payment Id</span><strong class="mono">{{ p.gatewayPaymentId || '—' }}</strong></div>
      </div>

      @if (isAdmin && p.gatewayResponseJson) {
        <details class="json-block">
          <summary>Gateway response (raw)</summary>
          <pre>{{ prettyJson(p.gatewayResponseJson) }}</pre>
        </details>
      }
    </div>
  }
</div>

<!-- ===================== RECEIPT DIALOG ===================== -->
<p-dialog [visible]="showReceipt()" (visibleChange)="showReceipt.set($event)" [modal]="true"
  [draggable]="true" [resizable]="false" [dismissableMask]="true" header="Payment Receipt"
  styleClass="menu-dialog" [style]="{ width: '720px' }" [breakpoints]="{ '720px': '94vw' }">
  @if (showReceipt() && payment(); as p) {
    <app-receipt-view [paymentId]="p.id" />
  }
</p-dialog>
